import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { PresignedUrl } from '../interfaces/pre-signed-url/pre-signed-url';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InspectionsService {
  url = '/api/inspections';

  constructor(public http: HttpClient) {}

  generatePreSignedUrlForInspectionUpload(taskId: number, filename: string): Promise<PresignedUrl> {
    return this.http
      .get<PresignedUrl>(
        this.url +
          `/${encodeURIComponent(taskId)}/teamsRecording/presignedUrl?fileName=${encodeURIComponent(
            filename,
          )}`,
      )
      .toPromise();
  }

  uploadFileToS3(file: File, presignedUrl: string): Observable<HttpEvent<any>> {
    return this.http.put(presignedUrl, file, {
      headers: new HttpHeaders({
        'Content-Type': file.type,
      }),
      reportProgress: true,
      observe: 'events',
    });
  }

  completeInspectionMediaUpload(
    taskId: number,
    fileName: string,
    objectKey: string,
    description: string,
  ): Promise<any> {
    let body = {
      objectKey: objectKey,
      originalFileName: fileName,
      description: description,
    };

    return this.http
      .post<any>(this.url + `/${encodeURIComponent(taskId)}/teamsRecording/complete`, body)
      .toPromise();
  }
}
